import { Controller } from '@hotwired/stimulus'

export default class RiskInvestmentTermsController extends Controller {
  static targets = ['checkbox', 'submitButton'];

  // The browser may restore a checked checkbox without firing change (back navigation, reload)
  checkboxTargetConnected() {
    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    this.submitButtonTarget.disabled = !this.checkboxTarget.checked;
  }
}
